/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps, useFieldHelper } from 'framework/ui/field';
import { ASSET_CATEGORIES_TYPES } from 'domain/finance/assets/useAssetService';

const AssetCategoryTypeField = ({ categorySource, source, ...props }: FieldProps & { categorySource: string }) => {
  const { getValue: getCategory } = useFieldHelper({ source: categorySource });
  const category = getCategory() as any;
  const options = ASSET_CATEGORIES_TYPES[category] || {};

  return <EnumField options={options} {...props} source={source} />;
};

export default AssetCategoryTypeField;
